class MrOnClickEvents extends HTMLElement {
	#colors = [
		'nyanza',
		'lavender',
		'magnolia',
		'floral-white',
		'blush',
		'azure',
		'seashell',
	];

	#shapes = [
		'star',
		'circle',
		'flower',
		'octagon',
	];

	#currentIndex = 0;

	#direction = 'forwards';

	#clickHandler = async() => {
		const audioClips = JSON.parse( this.getAttribute( 'data-audio-sources' ) ?? '[]' ).filter( ( x: string|null ) => {
			return !!x;
		} ) as Array<string>;

		if ( this.#direction === 'forwards' ) {
			this.#currentIndex++;
		} else {
			this.#currentIndex--;
		}

		if ( this.#currentIndex >= audioClips.length - 1 ) {
			this.#direction = 'backwards';
		} else if ( this.#currentIndex <= 0 ) {
			this.#direction = 'forwards';
		}

		this.setAttribute( 'data-color', this.#colors[this.#currentIndex % this.#colors.length] );
		this.setAttribute( 'data-shape', this.#shapes[this.#currentIndex % this.#shapes.length] );

		try {
			const clip = audioClips[this.#currentIndex];
			if ( clip ) {
				const audio = new Audio( clip );
				await audio.play();
			}
		} catch {
			// noop
		}
	};

	connectedCallback() {
		this.setAttribute( 'data-color', this.#colors[this.#currentIndex % this.#colors.length] );
		this.setAttribute( 'data-shape', this.#shapes[this.#currentIndex % this.#shapes.length] );

		this.addEventListener( 'click', this.#clickHandler );
	}

	disconnectedCallback() {
		this.removeEventListener( 'click', this.#clickHandler );
	}
}

window.customElements.define( 'mr-on-click-events', MrOnClickEvents );
